import { render, staticRenderFns } from "./SignUpBankAccount.vue?vue&type=template&id=78be5c27&scoped=true"
import script from "./SignUpBankAccount.vue?vue&type=script&lang=js"
export * from "./SignUpBankAccount.vue?vue&type=script&lang=js"
import style0 from "./SignUpBankAccount.vue?vue&type=style&index=0&id=78be5c27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be5c27",
  null
  
)

export default component.exports